/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { User } from '../models/user';
@Injectable({
  providedIn: 'root',
})
class UserService extends __BaseService {
  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `UserService.UserListParams` containing the following parameters:
   *
   * - `search`: A search term.
   *
   * - `ordering`: Which field to use when ordering the results.
   *
   * - `offset`: The initial index from which to return the results.
   *
   * - `limit`: Number of results to return per page.
   */
  userListResponse(params: UserService.UserListParams): __Observable<__StrictHttpResponse<{count: number, next?: null | string, previous?: null | string, results: Array<User>}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.search != null) __params = __params.set('search', params.search.toString());
    if (params.ordering != null) __params = __params.set('ordering', params.ordering.toString());
    if (params.offset != null) __params = __params.set('offset', params.offset.toString());
    if (params.limit != null) __params = __params.set('limit', params.limit.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/user/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{count: number, next?: null | string, previous?: null | string, results: Array<User>}>;
      })
    );
  }
  /**
   * @param params The `UserService.UserListParams` containing the following parameters:
   *
   * - `search`: A search term.
   *
   * - `ordering`: Which field to use when ordering the results.
   *
   * - `offset`: The initial index from which to return the results.
   *
   * - `limit`: Number of results to return per page.
   */
  userList(params: UserService.UserListParams): __Observable<{count: number, next?: null | string, previous?: null | string, results: Array<User>}> {
    return this.userListResponse(params).pipe(
      __map(_r => _r.body as {count: number, next?: null | string, previous?: null | string, results: Array<User>})
    );
  }

  /**
   * @param data undefined
   */
  userCreateResponse(data: User): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/user/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      })
    );
  }
  /**
   * @param data undefined
   */
  userCreate(data: User): __Observable<User> {
    return this.userCreateResponse(data).pipe(
      __map(_r => _r.body as User)
    );
  }

  /**
   * @param id A unique integer value identifying this user.
   */
  userReadResponse(id: number): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/user/${id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      })
    );
  }
  /**
   * @param id A unique integer value identifying this user.
   */
  userRead(id: number): __Observable<User> {
    return this.userReadResponse(id).pipe(
      __map(_r => _r.body as User)
    );
  }

  /**
   * @param params The `UserService.UserUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this user.
   *
   * - `data`:
   */
  userUpdateResponse(params: UserService.UserUpdateParams): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.data;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/user/${params.id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      })
    );
  }
  /**
   * @param params The `UserService.UserUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this user.
   *
   * - `data`:
   */
  userUpdate(params: UserService.UserUpdateParams): __Observable<User> {
    return this.userUpdateResponse(params).pipe(
      __map(_r => _r.body as User)
    );
  }

  /**
   * @param params The `UserService.UserPartialUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this user.
   *
   * - `data`:
   */
  userPartialUpdateResponse(params: UserService.UserPartialUpdateParams): __Observable<__StrictHttpResponse<User>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.data;
    let req = new HttpRequest<any>(
      'PATCH',
      this.rootUrl + `/user/${params.id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<User>;
      })
    );
  }
  /**
   * @param params The `UserService.UserPartialUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this user.
   *
   * - `data`:
   */
  userPartialUpdate(params: UserService.UserPartialUpdateParams): __Observable<User> {
    return this.userPartialUpdateResponse(params).pipe(
      __map(_r => _r.body as User)
    );
  }

  /**
   * @param id A unique integer value identifying this user.
   */
  userDeleteResponse(id: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/user/${id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id A unique integer value identifying this user.
   */
  userDelete(id: number): __Observable<null> {
    return this.userDeleteResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module UserService {

  /**
   * Parameters for userList
   */
  export interface UserListParams {

    /**
     * A search term.
     */
    search?: string;

    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;

    /**
     * The initial index from which to return the results.
     */
    offset?: number;

    /**
     * Number of results to return per page.
     */
    limit?: number;
  }

  /**
   * Parameters for userUpdate
   */
  export interface UserUpdateParams {

    /**
     * A unique integer value identifying this user.
     */
    id: number;
    data: User;
  }

  /**
   * Parameters for userPartialUpdate
   */
  export interface UserPartialUpdateParams {

    /**
     * A unique integer value identifying this user.
     */
    id: number;
    data: User;
  }
}

export { UserService }
